import { render, staticRenderFns } from "./PurchaseMgmt.vue?vue&type=template&id=b1e18558"
import script from "./PurchaseMgmt.vue?vue&type=script&lang=js"
export * from "./PurchaseMgmt.vue?vue&type=script&lang=js"
import style0 from "./PurchaseMgmt.vue?vue&type=style&index=0&id=b1e18558&prod&lang=scss"
import style1 from "./PurchaseMgmt.vue?vue&type=style&index=1&id=b1e18558&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports